module.exports = __webpack_public_path__ + "static/media/6.5568a246.jpg";